import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination } from "swiper/modules";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";

import "./Travel_Gallery.css";
import Common_Title from "../../common_component/common_title/Common_Title";
import { getData } from "../../../utils/api";
import { useEffect, useState } from "react";

const TravelGallery = () => {
  const images = [
    "/assets/images/holidays/travel_gallery/gallery_1.png",
    "/assets/images/holidays/travel_gallery/gallery_2.png",
    "/assets/images/holidays/travel_gallery/gallery_3.png",
    "/assets/images/holidays/travel_gallery/gallery_4.png",
    "/assets/images/holidays/travel_gallery/gallery_5.png",
    "/assets/images/holidays/travel_gallery/gallery_1.png",
    "/assets/images/holidays/travel_gallery/gallery_2.png",
    "/assets/images/holidays/travel_gallery/gallery_3.png",
    "/assets/images/holidays/travel_gallery/gallery_4.png",
    "/assets/images/holidays/travel_gallery/gallery_5.png",
  ];

  const [packages, setPackage] = useState([]);

  const getPackageAll = async () => {
    const response = await getData(`/master/gallery/`);

    setPackage(response?.data);
  };

  useEffect(() => {
    getPackageAll();
  }, []);

  return (
    <section className="tg-gallery">
      <div className="container">
        <Common_Title title="Travel Gallery" />

        <div className="gallery_swiper">
          <Swiper
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            loop={true}
            slidesPerView={4}
            spaceBetween={80}
            autoplay={{
              delay: 1000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              320: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              576: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 60,
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 80,
              },
            }}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: false,
            }}
            pagination={{ clickable: true }}
            modules={[EffectCoverflow, Pagination, Autoplay]}
            className="tg-swiper"
          >
            {packages.map((img, index) => (
              <SwiperSlide key={index} className="tg-slide-item">
                <div className="tg-image-card">
                  <img src={img?.image} alt={`Gallery ${index}`} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default TravelGallery;
